// extracted by mini-css-extract-plugin
export default {"IssueStatusChip_container":"styles_IssueStatusChip_container__VdO-w","completed":"styles_completed__tJYVC","forReview":"styles_forReview__QKXgF","rejected":"styles_rejected__oaw8s"};